import './Styles/Create.scss';

function Create(){
    return(
        <div className="create-prototype">
            <div className="image-part">
            <div className="card" data-aos="zoom-in"
              data-aos-delay={300}>
                <h3>Background</h3>
                <div className="circles">
                    <h2>91F2F6</h2>
                    <div className="circle"></div>
                    <div className="circle circle2"></div>
                  </div>
                  <div className="labels">
                      <p>Screen lables</p>
                      <p className="link">Manage</p>
                  </div>
                  <div className="buttons">
                      <div className="btngroup">
                          In Progress
                      </div>
                      <div className="btngroup group2">
                          Need Review
                      </div>
                      <div className="btngroup group 3">
                        Completed
                      </div>
                  </div>
              </div>
            </div>
            <div className="content">
                <h1>Create realistic prototypes, without code</h1>
                <p>In less than 5 minutes, transform your design mockups into interactive, online prototypes without writing a single line of code.</p>
                <p>Simply pull in screens made from Sketch, our design tool, or upload your own images - and add hotspots, interactions and layers as you wish.</p>
            </div>
        </div>
    )
};
export default Create ;